// Yup validation schema
import * as yup from "yup";

const EMAIL_REGEX = /^\w+([.-]?\w+)@\w+([.-]?\w+)(\.\w{2,3})+$/;

export const courierValidationSchema = yup.object().shape({
  name: yup.string().required("Company name is required"),
  phoneNumber: yup
    .string()
    .matches(/^\d+$/, "Phone number must contain only digits")
    .required("Phone number is required"),
  email: yup
    .string()
    .matches(EMAIL_REGEX, "Invalid email format. Example: name@example.com")
    .required("Email is required"),
  status: yup.string().required("Status is required"),
});
